import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const Candidates3DIcon = (t0)=>{
    const $ = c(7);
    const { width, height, color } = t0;
    let t1;
    if ($[0] !== color) {
        t1 = /*#__PURE__*/ jsxs("g", {
            filter: "url(#filter0_i_3982_59686)",
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M30.0008 18C30.0008 16.011 28.3898 14.4 26.4008 14.4C24.4118 14.4 22.8008 16.011 22.8008 18C22.8008 19.989 24.4118 21.6 26.4008 21.6C28.3898 21.6 30.0008 19.989 30.0008 18ZM19.2008 27V27.8955C19.2008 28.395 19.6057 28.8 20.1053 28.8H32.6963C33.1958 28.8 33.6008 28.395 33.6008 27.8955V27C33.6008 23.85 28.8038 22.95 26.4008 22.95C23.9978 22.95 19.2008 23.85 19.2008 27Z",
                    fill: color
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.5779 7.19995C17.5988 7.19996 17.6198 7.19996 17.6408 7.19996L35.2237 7.19995C35.8417 7.19991 36.4092 7.19987 36.8837 7.23863C37.3952 7.28043 37.9548 7.3761 38.5075 7.65773C39.2978 8.0604 39.9403 8.70292 40.343 9.4932C40.6246 10.0459 40.7203 10.6055 40.7621 11.1171C40.8009 11.5915 40.8008 12.159 40.8008 12.777V30.4229C40.8008 31.0409 40.8009 31.6084 40.7621 32.0829C40.7203 32.5944 40.6246 33.154 40.343 33.7067C39.9403 34.497 39.2978 35.1395 38.5075 35.5422C37.9548 35.8238 37.3952 35.9195 36.8837 35.9613C36.4092 36 35.8417 36 35.2237 36H17.5778C16.9599 36 16.3923 36 15.9179 35.9613C15.4064 35.9195 14.8468 35.8238 14.294 35.5422C13.5037 35.1395 12.8612 34.497 12.4586 33.7067C12.1769 33.154 12.0813 32.5944 12.0395 32.0829C12.0007 31.6084 12.0007 31.0408 12.0008 30.4229L12.0008 12.84C12.0008 12.8189 12.0008 12.798 12.0008 12.777C12.0007 12.1591 12.0007 11.5915 12.0395 11.1171C12.0813 10.6055 12.1769 10.0459 12.4586 9.4932C12.8612 8.70292 13.5037 8.0604 14.294 7.65773C14.8468 7.3761 15.4064 7.28043 15.9179 7.23863C16.3923 7.19987 16.9599 7.19991 17.5779 7.19995ZM15.9149 10.8713C15.9148 10.8713 15.916 10.8708 15.9185 10.87L15.9149 10.8713ZM15.9211 10.8691C15.9424 10.8625 16.0219 10.8421 16.211 10.8267C16.5209 10.8014 16.939 10.8 17.6408 10.8H35.1608C35.8625 10.8 36.2806 10.8014 36.5905 10.8267C36.7797 10.8421 36.8592 10.8625 36.8805 10.8691C36.9876 10.9256 37.0752 11.0131 37.1316 11.1203C37.1382 11.1416 37.1586 11.2211 37.1741 11.4102C37.1994 11.7201 37.2008 12.1382 37.2008 12.84V30.36C37.2008 31.0617 37.1994 31.4798 37.1741 31.7897C37.1586 31.9788 37.1382 32.0583 37.1316 32.0797C37.0752 32.1868 36.9876 32.2743 36.8805 32.3308C36.8592 32.3374 36.7797 32.3578 36.5905 32.3732C36.2806 32.3986 35.8625 32.4 35.1608 32.4H17.6408C16.939 32.4 16.5209 32.3986 16.211 32.3732C16.0219 32.3578 15.9424 32.3374 15.9211 32.3308C15.814 32.2743 15.7264 32.1868 15.67 32.0797C15.6633 32.0583 15.643 31.9788 15.6275 31.7897C15.6022 31.4798 15.6008 31.0617 15.6008 30.36V12.84C15.6008 12.1382 15.6022 11.7201 15.6275 11.4102C15.643 11.2211 15.6633 11.1416 15.67 11.1203C15.7264 11.0131 15.814 10.9256 15.9211 10.8691ZM15.6721 11.1141C15.6722 11.1141 15.6717 11.1154 15.6708 11.1177L15.6721 11.1141ZM15.6721 32.0859C15.6721 32.0859 15.6716 32.0848 15.6708 32.0823L15.6721 32.0859ZM15.9149 32.3286C15.915 32.3286 15.9162 32.329 15.9185 32.3299L15.9149 32.3286ZM36.8867 32.3286C36.8868 32.3286 36.8856 32.3291 36.8831 32.33L36.8867 32.3286ZM37.1294 32.0859C37.1294 32.0858 37.1298 32.0845 37.1308 32.0822L37.1294 32.0859ZM37.1294 11.1141C37.1295 11.114 37.1299 11.1151 37.1308 11.1176L37.1294 11.1141ZM36.8831 10.87C36.8856 10.8708 36.8868 10.8713 36.8867 10.8713L36.8831 10.87Z",
                    fill: color
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.40078 15V27.96C8.40078 30.3419 8.40218 32.0201 8.50925 33.3305C8.6146 34.6199 8.81321 35.3939 9.12014 35.9963C9.7529 37.2382 10.7626 38.2478 12.0044 38.8806C12.6068 39.1875 13.3809 39.3861 14.6703 39.4915C15.9807 39.5986 17.6589 39.6 20.0408 39.6H33.0008C33.0008 41.5882 31.389 43.2 29.4008 43.2H19.9625C17.6766 43.2 15.8513 43.2 14.3771 43.0795C12.8651 42.956 11.5646 42.6968 10.3701 42.0882C8.45083 41.1103 6.89042 39.5499 5.91252 37.6307C5.3039 36.4362 5.04474 35.1357 4.9212 33.6236C4.80075 32.1494 4.80077 30.3241 4.80078 28.0382L4.80078 18.6C4.80078 16.6117 6.41256 15 8.40078 15Z",
                    fill: color
                })
            ]
        });
        $[0] = color;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ jsx("defs", {
            children: /*#__PURE__*/ jsxs("filter", {
                id: "filter0_i_3982_59686",
                x: "3.80078",
                y: "7.19995",
                width: "37",
                height: "37",
                filterUnits: "userSpaceOnUse",
                colorInterpolationFilters: "sRGB",
                children: [
                    /*#__PURE__*/ jsx("feFlood", {
                        floodOpacity: "0",
                        result: "BackgroundImageFix"
                    }),
                    /*#__PURE__*/ jsx("feBlend", {
                        mode: "normal",
                        in: "SourceGraphic",
                        in2: "BackgroundImageFix",
                        result: "shape"
                    }),
                    /*#__PURE__*/ jsx("feColorMatrix", {
                        in: "SourceAlpha",
                        type: "matrix",
                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                        result: "hardAlpha"
                    }),
                    /*#__PURE__*/ jsx("feOffset", {
                        dx: "-1",
                        dy: "1"
                    }),
                    /*#__PURE__*/ jsx("feGaussianBlur", {
                        stdDeviation: "0.5"
                    }),
                    /*#__PURE__*/ jsx("feComposite", {
                        in2: "hardAlpha",
                        operator: "arithmetic",
                        k2: "-1",
                        k3: "1"
                    }),
                    /*#__PURE__*/ jsx("feColorMatrix", {
                        type: "matrix",
                        values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.211765 0 0 0 0.12 0"
                    }),
                    /*#__PURE__*/ jsx("feBlend", {
                        mode: "normal",
                        in2: "shape",
                        result: "effect1_innerShadow_3982_59686"
                    })
                ]
            })
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== height || $[4] !== t1 || $[5] !== width) {
        t3 = /*#__PURE__*/ jsxs("svg", {
            width: width,
            height: height,
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t1,
                t2
            ]
        });
        $[3] = height;
        $[4] = t1;
        $[5] = width;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
export { Candidates3DIcon };
